import request from '@/utils/https';

// 登录手机号
export const loginPhone = (data) => {
  return request({
    url: `/web/auth/phoneLogin`,
    method: 'post',
    data
  });
}

// 登录邮箱
export const loginEmail = (data) => {
  return request({
    url: `/web/auth/emailLogin`,
    method: 'post',
    data
  });
}

/**
 * 注销
 */
export const logout = () => {
  return request({
    url: '/auth/logout',
    method: 'post'
  });
}

// 获取手机短信验证码
export const getPhoneCode = (params) => {
  return request({
    url: `/web/auth/phone/code`,
    method: 'get',
    params
  });
}

// 获取邮箱验证码
export const getEmailCode = (data) => {
  return request({
    url: `/web/auth/email/code`,
    method: 'post',
    data
  });
}

// 校验验证码
export const checkCode = (data) => {
  return request({
    url: `/web/auth/validate/code`,
    method: 'post',
    data
  });
}

// 注册
export const register = (data) => {
  return request({
    url: `/web/auth/register`,
    method: 'post',
    data
  });
}

// 验证码登录 - 手机号登录 - /web/auth/smsLogin
export const smsLogin = (data) => {
  return request({
    url: `/web/auth/smsLogin`,
    method: 'post',
    data
  });
}

// 验证码登录 - 邮箱登录 - /web/auth/mailLogin
export const mailLogin = (data) => {
  return request({
    url: `/web/auth/mailLogin`,
    method: 'post',
    data
  });
}

// 切换身份
export const changeIdentity = (type) => {
  return request({
    url: `/auth/switchUserType?userType=` + type,
    method: 'get',
  });
}
//登录
export const loginV2 = (data) => {
  return request({
    url: `/auth/uaa/login/v2`,
    method: 'post',
    data,
  });
}
//获取用户个人档案
export const getStuInfo = (userId) => {
  return request({
    url: `/edu/web/stu/${userId}`,
    method: 'get',
  });
}
export const teaRegister = (data) => {
  return request({
    url: `/edu/teacherInfo/register`,
    method: 'post',
    data
  });
}

// 学生注册
export const stuRegister = (data) => {
  return request({
    url: `/edu/studentInfo/register`,
    method: 'post',
    data
  });
}
//学生登录判断是否首次登陆/edu/web/stu/getImproveStatus/{userId}
export const getImproveStatus = (userId) => {
  return request({
    url: `/edu/web/stu/getImproveStatus/${userId}`,
    method: 'get',
  });
}

